export const CSS = {
  scrim: "scrim",
  container: "container",
  containerOpen: "container--open",
  content: "content",
  containerSlottedInShell: "container--slotted-in-shell",
};
